import { ApiYAxisChartType } from "@incendium/api";
import { StyledComposedChart } from "features/analytics";
import Loading from "Components/Loading/Loading";
import { TChartData } from "Interfaces";
import GlassCard from "Components/GlassCard/GlassCard";
import { Box, Typography } from "@mui/material";

interface PushedMetaEventsChartProps {
  chartData: TChartData[];
  loading: boolean;
}

function PushedMetaEventsChart({ chartData, loading }: PushedMetaEventsChartProps) {
  if (loading) {
    return <Loading sx={{ height: 280 }} />;
  }

  return (
    <GlassCard
      boxProps={
        { px: 2, pt: 2.5, pb: 3 }
      }
      sx={{
        overflow: "hidden",
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      <Typography variant="subtitle1" mb={1}>Meta Signal Tracking</Typography>
      <Box sx={{ height: "calc(100% - 40px)" }}>
        <StyledComposedChart
          data={chartData}
          // height={280}>
          noReOrder
          showTooltip
          metricsOrder={["pushed", "blocked"]}
          yAxisKeys={[
            {
              key: "l",
              fields: ["pushed", "blocked"],
              chart: { pushed: ApiYAxisChartType.LINE, blocked: ApiYAxisChartType.LINE },
            },
          ]}
        />
      </Box>
    </GlassCard>
  );
}

export default PushedMetaEventsChart;
